<template>
  <div class="debtorDetail_warpper" ref="debtorDetail_warpper">
    <nav-bar titleText="解债订单" @goBack="goBack"></nav-bar>
    <div class="content1" ref="content1">
      <div class="content-box">
        <div class="detail_title">{{process_status}}</div>
        <van-row class="introduce_row">
        <van-col class="debtor_introduce" span="10">
          <div class="introduceBody">
            <p class="introduce_type">债务人</p>
            <p class="introduce_name" v-if="dataSource.debtor_name || dataSource.debtor_company_name">{{is_supplement== 1 ? dataSource.debtor_name : (dataSource.debtor_name || dataSource.debtor_company_name) | formatName}}</p>
            <p class="introduce_tel">{{dataSource.debtor_mobile }}</p>
            <p class="introduce_code">{{code}}</p>
          </div>
        </van-col>
        <van-col class="process" span="4">
          <div class="processBody">
            <p class="reimbursement">还款</p>
            <div class="process_icon">
              <van-icon class="phase" name="play" :style="{ color: '#b3b0b0'}" />
              <van-icon class="phase" name="play" :style="{ color: '#848181'}" />
              <van-icon class="phase" name="play" :style="{ color: '#3a3939'}" />
            </div>
          </div>
        </van-col>
        <van-col class="creditors_introduce" span="10">
          <div class="creditorsBody">
            <p class="introduce_type">债权人</p>
            <p class="introduce_name">{{dataSource.creditor_name}}</p>
            <p class="introduce_tel">{{dataSource.creditor_mobile}}</p>
            <p class="introduce_code">{{IDCard}}</p>
          </div>
        </van-col>
        </van-row>
      </div>

      <div
        class="viewEleContract"
        v-if="dataSource.status===60 || dataSource.status===130 || dataSource.status===120 "
        @click="handlElectroniContract()"
      >查看电子合同</div>
      <div class="order_details">
        <p class="order_title">订单详情 <span class="red-text" v-show="is_supplement == 1">(补录)</span></p>
        <p class="order_content">解债金额 ¥{{parseFloat(amount).toFixed(2)}}</p>
        <p class="order_content" style="color: #999">(包含本金￥{{dataSource.amount}}、利息￥{{dataSource.interest_amount}})</p>
        <p class="order_content">减免债务金额 ¥{{dataSource.reduction_amount}}</p>
        <p :class="[['10','13','70','25','50',].includes(dataSource.status) ? 'color_333' : 'color_org']">需偿还债务金额 ¥{{needRepaymentMoney}}</p>
        <!-- <p class="order_content">打款帐号 {{dataSource.pay_account}}</p> -->
        <!-- <p class="order_content">订单号 {{dataSource.order_sn}}</p> -->
        <div class="ordersn">
          <div class="left">
            <span>订单号&nbsp;</span>
            <span ref="copytxt">{{dataSource.order_sn}}</span>
          </div>
          <div class="right" @click="copyOrdersn">复制</div>
        </div>
        <p class="order_content">经纪人代码 {{dataSource.agent_code}}</p>
        
        <p class="order_content" v-show="is_supplement == 0">创建订单时间 {{dataSource.created_at}}</p>
         <p class="order_content" v-if="dataSource.creditor_confirm_time && is_supplement== 0" >债权人确认时间 {{dataSource.creditor_confirm_time}}</p>
        <p class="order_content" v-if="dataSource.debtor_confirm_time && is_supplement== 0" >债务人确认时间 {{dataSource.debtor_confirm_time}}</p>
        <p class="order_content" v-if="[30, 40, 50, 60, 85, 90, 100, 110, 120,130].includes(dataSource.status) && is_supplement== 0" >平台审核通过时间 {{dataSource.platform_adopt_time}}</p>
        <p class="order_content" v-if="[40, 50, 60, 90, 100, 110,120, 130].includes(dataSource.status) && is_supplement== 0">财务审核通过时间 {{dataSource.finance_adopt_time}}</p>
        <p class="order_content" v-if="[50, 60, 100, 110,120, 130].includes(dataSource.status) && is_supplement== 0">合同审批通过时间 {{dataSource.contract_adopt_time}}</p>
        <p class="order_content" v-if="[60,120].includes(dataSource.status) && is_supplement== 0">合同签署完成时间 {{dataSource.effect_time}}</p>
        <p class="order_content" v-if="[60,130].includes(dataSource.status) && is_supplement== 1">合同签署完成时间 {{dataSource.contract_sign_time}}</p>
        <p class="order_content" v-if="[130].includes(dataSource.status) && is_supplement== 1">债权回收完成时间 {{dataSource.debt_complete_time}}</p>
        <p class="order_content" v-if="[70].includes(dataSource.status)">债权人驳回时间 {{dataSource.creditor_reject_time}}</p>
        <p class="order_content" v-if="[75].includes(dataSource.status)">债务人驳回时间 {{dataSource.debtor_reject_time}}</p>
        <p class="order_content" v-if="[80].includes(dataSource.status)">平台驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[85].includes(dataSource.status)">财务驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[90].includes(dataSource.status)">合同驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[100].includes(dataSource.status)">合同撤回时间 {{dataSource.contract_revoke_time}}</p>
        <p class="order_content" v-if="[110].includes(dataSource.status)">合同失效时间 {{dataSource.contract_expire_time}}</p>

        <!-- 合同作废显示时间 -->
        <p class="order_content" v-if="[120].includes(dataSource.status)">合同作废时间 {{dataSource.contract_void_time}}</p>
        <!-- 合同作废显示时间 -->

        <p class="order_content" v-if="[70].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.creditor_reject_remark}}</span></p>
        <p class="order_content" v-if="[75].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.debtor_reject_remark}}</span></p>
        <p class="order_content" v-if="[80].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        <p class="order_content" v-if="[85].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        <p class="order_content" v-if="[90].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        
        <div class="empty-placehoder" v-if="dataSource.status == 23"></div>
        <!-- <div class="info van-clearfix" v-if="[13,23, 25, 30, 40, 50, 60,75,80,85,90,100,110,120,130].includes(dataSource.status)">
          <div class="collect_details" style="padding-bottom:0">
            <p class="uploadText">
                借据凭证
              </p>
            <van-uploader @oversize="onOversize" :preview-size="img_height"
             v-model="receipt_img_list" :deletable="false"  :max-count="receipt_img_list.length"  multiple />
          </div>
        </div> -->
        <div class="info van-clearfix" v-if="[10, 20, 23, 25, 30, 40, 50, 60, 70,80,85,90,100,110,120,130].includes(dataSource.status)">
          <div class="collect_details">
            <p class="color999 payment_account" v-if="dataSource.status == 23 && is_supplement== 0">请债务人本人将需偿还债务金额汇至下方万融收款账号（手机银行、网上银行、柜台均可），注意：打款不要备注。完成后在下面将显示付款方、收款方的成功打款回单详情图作为打款凭证进行上传。</p>
            <p class="marTop6" v-if="dataSource.status == 23 && is_supplement== 0">收款人名称 {{confirmOrderInfo.debt_receive_bank_owner}}</p>
            <p class="marTop6" v-if="dataSource.status == 23 && is_supplement== 0">收款银行 {{confirmOrderInfo.debt_receive_bank_name}}</p>
            <p class="marTop6" v-if="dataSource.status == 23 && is_supplement== 0">收款账号 {{confirmOrderInfo.debt_receive_bank_no}}</p>
            <p class="uploadText" v-if="(fileList.length && is_supplement== 1) || is_supplement==0">
              打款凭证
            </p>
            <div class="uploadBox" :style="uploadBoxStyle" v-if="(fileList.length && is_supplement== 1) || is_supplement==0">
              <!--upload_title 打款凭证-->
              <van-uploader
                v-model="fileList"
                multiple 
                :max-count="uploadMax"
                :deletable="uploadDeletable"
                :preview-size="img_height"
                @oversize="onOversize"
                @delete="deleteFile1"
                :after-read="afterRead"
                :before-read="beforeRead"
              >
                <div class="box" :style="boxStyle">
                  <div class="icon">+</div>
                  <div class="title">打款凭证</div>
                </div>
              </van-uploader>
            </div>
          </div>
        </div>

        <div class="operation-box" v-if="operationObj.operation1_btn || operationObj.operation2_btn">
          <div class="operation" v-if="operationObj.operation1_btn">
            <van-button
              v-if="operationObj.operation1_btn"
              type="primary"
              :loading="operation_loading"
              class="operation_btn"
              @click="handleClick(operationObj.type)"
            >{{operationObj.operation_text}}</van-button>
          </div>
          <div class="rejected" v-if="operationObj.operation2_btn">
            <van-button
              v-if="operationObj.operation2_btn"
              type="primary"
              @click="handleRejected(operationObj.reject)"
              class="operation_btn"
            >{{operationObj.callBack}}</van-button>
          </div>
        </div>
      </div>
    </div>





    <div class="dialog1">
      <van-dialog
        v-model="show"
        title="确认驳回"
        show-cancel-button
        confirm-button-color="#F9591B"
        :before-close="beforeClose"
      >
        <div class="modalBody">
          <p>请填写驳回理由</p>
          <textarea
            :maxlength="sum_text"
            placeholder="请输入..."
            ref="description"
            @keyup="wordlimit()"
          ></textarea>
          <span>{{this.number}}/{{this.sum_text}}</span>
        </div>
      </van-dialog>
    </div>

    <div class="dialog2">
      <van-dialog
        v-model="showDialog2"
        title="提示"
        message="确认通过此解债订单？"
        confirm-button-text="确认"
        confirm-button-color="#F9591B"
        cancel-button-text="取消"
        cancel-button-color="#999999"
        @confirm="confirmEvent"
        show-cancel-button
      >
      </van-dialog>
    </div>

    <div class="loading5" v-if="loading5">
      <img src="../../../assets/common/loading.gif"/>
    </div>

  </div>
</template>
<script>
import navBar from "../components/navBar";
// import uploader from "../components/uploader";
import {uploadMixin} from "../mixin"
export default {
  name: "debtorDetail",
  data() {
    return {
      total_amount: "360000.000", //总还款
      operation_loading: false, //发送请求避免重复提交
      percentage: 0,
      creditor_phone: 0,
      value4: 0,
      value6: 0,
      code: "",
      IDCard: "",
      fileList: [
        { url: "https://static.erp321.com/seller/20081516747549.jpg" }, //默认图片地址
      ],
      // receipt_img: "",
      show_pivot: false,
      token: "",
      process_status: "",
      amount: 0, //还款金额
      operationObj: {
        operation1_btn: false, //是否显示操作按钮1
        operation2_btn: false, //是否显示操作按钮2
        callBack: "撤回", //查看电子合同/驳回//撤回/查看电子合同/删除订单
        operation_text: "提交", //签署电子合同/提交/通过/签署合同
        type: "", //签署电子合同:electronic_contract
        reject: "", //删除订单
      },

      dataSource: {},
      is_cert: -1,
      needRepaymentMoney: 0,
      showDialog2: false,
      show: false,
      sum_text: 40,
      number: 0,
      confirmOrderInfo: {},
      // 新增upload修改  写死99px
      img_height: '99px',
      fileList: [],
      fileList1: [],
      fileNameMap: {},
      loading5: false,
      uploadMax: 8,
      uploadDeletable: false,
      receipt_img_list:[],
      is_supplement:0,
    };
  },
  components: {
    navBar,
  },
  computed: {
    uploadBoxStyle(){
      if (this.dataSource.status == 23) {
        return { 'height': this.img_height, 'margin-top': '18px' }
      }
      return { 'height': this.img_height, 'margin-top': '6px' }
    },
    boxStyle(){
      return { width: this.img_height, height: this.img_height }
    },
  },
  mixins: [uploadMixin],
  filters: {
    formatName(value) {
      if (value.length <= 8) {
        return value
      }
      if (value.length > 8) {
        return `${value.slice(0, 7)}...`
      }
    },
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad()
    this.confirmOrder()
  },

  mounted() {
    setTimeout(() => {}, 300);
  },
  methods: {
    runScroll() {
      if([23].includes(this.dataSource.status)){
        const parentDom = this.$refs.debtorDetail_warpper
        const parentHeight = parentDom.offsetHeight
        const sonHeight = this.$refs.content1.offsetHeight

        const shouldScrollHeight = parentHeight - sonHeight + 88
        setTimeout(() => {
          parentDom.scrollTop = shouldScrollHeight
        },500)
      }
    },
    confirmOrder() {
      this.$api.post('debt/member/debtor-order/confirm').then(data => {
        this.confirmOrderInfo = data
      })
    },
    afterRead(file){
      this._afterRead(file, 'voucher', this.fileList, this.fileList1, this.fileNameMap)
    },
    deleteFile1(file){
      this.deleteFile(file, this.fileList1, this.fileNameMap)
    },
    goBack() {
      // this.params("", "", "goBack");
      if (this.$route.query.debt_from === 'list') {
        this.$router.go(-1)
        return
      }
      this.$router.push('/debtor/debtorView')
    },
    wordlimit() {
      let textVal = this.$refs.description.value;
      this.number = textVal.length;
      let length;
      length = parseInt(this.sum_text) - parseInt(textVal.length);
      if (length < 0) {
        length = 0;
      }
      this.limit = length;
      if (textVal.length >= this.sum_text) {
        this.$refs.description.value = textVal.substring(0, this.sum_text);
      }
    },
    confirmEvent(){
      this.$api
      .post("/debt/member/debtor-order/adopt", {
        // order_id: 2,
        id: this.$route.query.order_id,
      })
      .then((res) => {
        this.$toast("审核通过，请上传打款凭证并提交")
        this.operationObj.operation1_btn = false
        this.operationObj.operation2_btn = false

        this.fileList = []
        this.receipt_img_list = []
        this.onLoad()
      })
      .catch((err) => {
        // console.log(err)
        err.message && console.log(err.message)
      })
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (!this.$refs.description.value) {
          done(false);
          this.$toast("驳回理由必填哦!");
        }else if (this.$refs.description.value.length <= 2) {
          done(false);
          this.$toast("债权人驳回原因长度必须大于2");
        }else {
          this.handleConfirm();
          done();
        }
      } else {
        done();
      }
    },
    handleConfirm() {
      const param = {
          id: this.$route.query.order_id,
          creditor_reject_remark: this.$refs.description.value,
        }
      this.$api
        .post("/debt/member/debtor-order/reject", param)
        .then((res) => {
          this.operationObj.operation1_btn = false;
          this.operationObj.operation2_btn = false;
          this.onLoad();
        })
        .catch((err) => {
          console.log(err)
          err.message && console.log(err.message)
        });
    },
    handleClick(btn1) {
      switch (btn1) {
        case "electronic_contract":
          this.$api.post('/debt/member/cert/is-cert')
          .then(data => {
            let is_company = 'no'
            // 2 表示是公司，签名盖章时需要判断
            if (data.is_cert == 2) {
              is_company = 'yes'
            }
            this.$router.push({
              path: '/debtor/signContract',
              query: {
                order_id: this.dataSource.id,
                contract_id: this.dataSource.contract_id,
                identity: 'debtor',
                is_company: is_company,
              },
            })
          })
          break;
          
        case "debetor_though":
          this.showDialog2 = true
          break;

        case "approval": //提交打款凭证
          if (this.fileList.length === 0) { 
            this.$toast("打款凭证不能为空！！！")
            return
          }
          this.loading5 = true

          // const constTimeout = 60
          // let count = 0
          this.timeId = setInterval(() => {
          //   count ++
          //   if (count >= constTimeout * 1000 / 200) {
          //     this.$toast('提交失败')
          //     clearInterval(timeId)
          //     this.loading5 = false
          //     return
          //   }

            if (this.fileList.length === this.fileList1.length) {
              clearInterval(this.timeId)
              this.$api
                .post("/debt/member/debtor-order/up-iou", {
                  id: this.$route.query.order_id,
                  payment_info: this.fileList1,
                })
                .then( (res) => {
                  this.$toast("提交成功");
                  this.uploadMax = 0
                  this.operationObj.operation1_btn = false;
                  this.uploadDeletable = false
                  // this.onLoad();
                  this.$router.push({
                    path: '/creditor/resultSubmitPayVoucher',
                    query: {
                      id: this.dataSource.id
                    },
                  })
                })
                .catch((err) => {
                  console.log(err)
                  err.message && this.$toast(err.message)
                })
                .finally(() => {
                  this.loading5 = false
                })
            }

          },200)



          // this.fileList = this.fileList.map(item => item.url)


          break;
      }
    },
    handleRejected(btn2) {
      switch (btn2) {
        case "view_electronic_contracts":
          this.$router.push({
            path: '/debtor/electroniContract',
            query: {
              contract_id: this.dataSource.contract_id,
            },
          })
          break;
        case "reject":
          this.show = true
          break;
      }
    },
    // handleOnChangeFile(val) {
    //   this.receipt_img = val;
    // },
    onLoad() {
      this.$api
        .post("debt/member/debtor-order/detail", {
          // id: 2, 
          id:this.$route.query.order_id
        })
        .then((data) => {
          this.is_supplement = data.is_supplement
          this.dataSource = data;
          this.amount = (parseFloat(this.dataSource.amount) + parseFloat(this.dataSource.interest_amount)).toFixed(2)          
          this.needRepaymentMoney = (parseFloat(this.dataSource.debt_amount) - parseFloat(this.dataSource.reduction_amount)).toFixed(2)
          this.percentage = parseInt((parseInt(this.dataSource.reduction_amount) / parseInt(this.dataSource.amount)) * 100)
          this.code = '****' + String(this.dataSource.debtor_id_number || this.dataSource.debtor_credit_code).slice(-4)
          this.IDCard = '****' + this.dataSource.creditor_id_number.slice(-4)
          this.runScroll()
         if(this.dataSource.receipt_img){
            this.dataSource.receipt_img.forEach(item => {
            this.receipt_img_list.push({
              url: item,
              isImage: true,
            })
          })
         }
          if ([10, 20, 25, 30, 40, 50, 60, 70,75,80,85,90,100,110,120,130].includes(this.dataSource.status)) {
            // TODO 使用时注释掉
            // this.dataSource.receipt_img = ['https://static.erp321.com/seller/20081516747549.jpg','https://static.erp321.com/seller/20081516747549.jpg','https://static.erp321.com/seller/20081516747549.jpg','https://static.erp321.com/seller/20081516747549.jpg','https://static.erp321.com/seller/20081516747549.jpg']
            if(this.dataSource.payment_info){
              if (Array.isArray(this.dataSource.payment_info)) {
              this.dataSource.payment_info.forEach(item => {
                this.fileList.push({
                  url: item,
                  isImage: true,
                })
              })
            }else {
              console.log('服务器返回打款凭证不为数组')
            }
           }
            this.uploadMax = 0
          }

          switch (this.dataSource.status) {
            case 10:
              this.process_status = "待债权人确认"
              break;
            case 13:
              this.process_status = "待债务人确认"
              this.operationObj.operation1_btn = true
              this.operationObj.operation2_btn = true
              this.operationObj.operation_text = "通过"
              this.operationObj.callBack = "驳回"
              this.operationObj.type = "debetor_though"
              this.operationObj.reject = "reject"

              break;
              // if (this.dataSource.sign_role === 0 || this.dataSource.sign_role === 1) {
              //   this.process_status = "待合同签名";
              //   this.operationObj.operation1_btn = true;
              //   this.operationObj.operation_text = "通过";
              //   this.operationObj.type = "electronic_contract"; //电子签名
              // }
              // if (this.dataSource.sign_role == 2) {
              //   this.process_status = "等待债权人签署合同";
              //   this.operationObj.operation2_btn = true;
              //   this.operationObj.callBack = "驳回";
              //   this.operationObj.reject = "view_electronic_contracts";
              // }
              // break;
            case 20:
              this.process_status = "待债权人上传借据凭证";
              break;
            case 23:
              this.process_status = "待债务人上传打款凭证";
              this.operationObj.operation1_btn = true
              this.operationObj.operation_text = "提交"
              this.operationObj.type = "approval"
              this.uploadDeletable = true
              break;
            case 25:
              this.process_status = "待平台审核";
              break;
            case 30:
              this.process_status = "待财务审核";
              break;
            case 40:
              this.process_status = "待合同审批";
              break;
            case 50: //sign_role  0：都没签  1: 债务人没签，债权人签了  2：债务人签了，债权人没签
              if (this.dataSource.sign_role === 0 || this.dataSource.sign_role === 1) {
                this.process_status = "待合同签名";
                this.operationObj.operation1_btn = true;
                this.operationObj.operation_text = "签署合同";
                this.operationObj.type = "electronic_contract"; //电子签名
              }
              if (this.dataSource.sign_role == 2) {
                this.process_status = "等待债权人签署合同";
                this.operationObj.operation2_btn = true;
                this.operationObj.callBack = "查看电子合同";
                this.operationObj.reject = "view_electronic_contracts";
              }
              break;
            case 60:
              this.process_status = "债权回收中";
              break;
            case 70:
              this.process_status = "债权人驳回";
              break;
            case 75:
              this.process_status = "债务人驳回";
              break;
            case 80:
              this.process_status = "平台驳回";
              break;
            case 85:
              this.process_status = "财务驳回";
              break;
            case 90:
              this.process_status = "合同审批驳回";
              break;
            case 100:
              this.process_status = "合同撤回";
              break;
            case 110:
              this.process_status = "合同失效";
              break;
            case 120:
              this.process_status = "合同作废";
              break;
            case 130:
              this.process_status = "债权回收完成";
              break;
            default:
              this.process_status = "订单状态异常";
          }
        })
        .catch((res) => {
          // console.log(res);
        });
    },
    //查看电子合同
   
    handlElectroniContract() {
      let query={
          contract_id: this.dataSource.contract_id,
        }
      if(this.is_supplement == 1){
        query =  {
          order_id: this.dataSource.id,
          is_supplement:this.dataSource.is_supplement
        }
      }
      this.$router.push({
        path:'/debtor/electroniContract',
        query:query
      })
    },
    reBack() {
      this.$router.go(-1);
    },
    copyOrdersn(){
        const debtor_range = document.createRange();
        debtor_range.selectNode(this.$refs.copytxt);
        const debtor_selection = window.getSelection();
        if(debtor_selection.rangeCount > 0) debtor_selection.removeAllRanges();
        debtor_selection.addRange(debtor_range);
        document.execCommand('Copy');
        this.$toast('复制成功')
        debtor_selection.removeAllRanges()
    },
  },
};
</script>
<style lang="less">
.debtorDetail_warpper {
  &::-webkit-scrollbar {
    display: none;
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  color: #333333;
  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .content1 {
    // margin: 12px;
    .payment_status {
      font-size: 15px;
      height: 30px;
      line-height: 30px;
    }
    .paymentBox {
      margin: 9px 0 15px;
    }
    .has_payment {
      font-size: 24px;
      font-weight: 600;
    }
    .total_amount {
      font-size: 16px;
      color: #999999;
    }
    .van-progress {
      background: rgb(254, 238, 232);
      height: 6px;
      width: 100%;
    }
    .color999 {
      color: #999999;
    }
    .marTop6 {
      margin-top: 6px;
    }
    .detail_title {
      font-size: 24px;
      font-weight: 600;
      margin: 18px 0 24px 0;
    }
    .content-box {
      padding: 12px 12px 0;
      background: linear-gradient(360deg, #F5F6F7 0%, #FFFFFF 100%);
    }
    .introduce_row {
      margin-bottom: 16px;
      margin-top: 15px;
    }
    .introduceBody,
    .creditorsBody {
      background-color: #fff;
      width: 100%;
      height: 139px;
      -webkit-box-shadow: 0px 0px 1px #000;
      box-shadow: 0px 0px 4px #dedada;
      text-align: center;
      border-radius: 6px;
      .introduce_type {
        color: #999999;
        font-size: 13px;
        padding: 15px 0 6px;
      }
      .introduce_name {
        color: #fc740c;
        font-size: 17px;
        height: 28px;
        font-weight: 600;
        line-height: 28px;
      }
      .introduce_tel {
        font-size: 15px;
        margin: 3px 0;
        height: 24px;
        line-height: 24px;
      }
      .introduce_code {
        color: #999999;
        font-size: 15px;
        padding-bottom: 14px;
        height: 24px;
        line-height: 24px;
      }
    }
    .process {
      text-align: center;
      height: 150px;
      .processBody {
        margin-top: 52px;
        .reimbursement {
          font-size: 15px;
        }
        .process_icon {
          .phase {
            width: 12px;
            height: 12px;
            margin: 6px 0px 0 0;
          }
        }
      }
    }
    .order_details {
      margin: 4px 12px 0;
      // width: 100%;
      background-color: #fff;
      font-size: 14px;
      border-radius: 6px;
      .order_title {
        color: #999999;
        padding: 15px 0 10px;
        margin-left: 15px;
      }
      .order_content {
        padding-bottom: 6px;
        margin-left: 15px;
        // height: 23px;
        line-height: 23px;
        .font-ew{
          font-weight: 600;
        }
      }      
      .color_org {
        padding-bottom: 6px;
        color: #f9591b;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      .color_333 {
        padding-bottom: 6px;
        color: #333;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      .ordersn {
        display: flex;
        justify-content: space-between;
        .left {
          padding-bottom: 6px;
          margin-left: 15px;
          height: 23px;
          line-height: 23px;
        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #F9591B;
          line-height: 23px;
          padding-right: 15px;
        }
      }
      p {
        .van-uploader__preview-image {
          width: 100px;
          height: 100px;
        }
      }
      .uploader {
        margin-left: 15px;
        height: 100px;
        width: 100px;
        margin-top: 3px;
      }
      .operation {
        background-color: #f5f6f7;
        .operation_btn {
          background-color: #fc740c;
          color: #fff;
          border: none;
        }
      }
      .rejected {
        margin: 24px 0 0;
        .operation_btn {
          background-color: #fff;
          color: #333;
          border: 1px solid #666;
        }
      }
      .operation_btn {
        width: 100%;
        /* margin: 24px 15px; */
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
      }
    }
  }
  .viewEleContract {
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: #fff;
    margin: 4px 12px 0;
    font-size: 15px;
  }

  .info.van-clearfix {
    background-color: #f5f6f7;
    margin: 0 12px;
  }
  .empty-placehoder {
    background-color: #f5f6f7;
    height: 12px;
    width: 100%;
  }
  .collect_details {
    background-color: #ffffff;
    padding: 15px 0 24px 0;
    overflow-x: scroll;
    // margin: 12px 12px 0;
    .payment_account {
      font-size: 13px;
      color: #999999;
      line-height: 21px;
      min-height: 21px;
      margin-bottom: 15px;
    }
    p {
      // height: 26px;
      line-height: 26px;
    }
  }


  // 新增upload修改
  .van-uploader__wrapper {
    flex-wrap: nowrap;
  }
  .uploadBox {
    // min-height: 100px;
    // 新增upload修改
    overflow-x: auto;
    overflow-y: hidden;
    .box {
      // width: 100px;
      // height: 100px;
      background-color: #fff;
      border: 1px dashed #dedede;
      box-sizing: border-box;
      .icon {
        text-align: center;
        color: #999999;
        height: 21px;
        line-height: 21px;
        margin: 27px 0 9px;
        font-size: 35px;
      }
      .title {
        text-align: center;
        font-size: 13px;
        height: 21px;
        line-height: 21px;
        color: #555555;
      }
    }
    // 新增upload修改
    .van-uploader__wrapper {
      flex-wrap: nowrap;
    }
    .van-uploader__preview {
      margin: 0 8px 0 0;
    }
    .van-uploader__preview-delete {
      position: absolute;
      top: 0px;
      right: 0px;
      color: #fff;
      font-size: 16px;
      // padding: 3px;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 0px 3px 0px 3px;
    }
    .van-icon-clear:before {
      content: "\F042";
    }
    .van-uploader__preview-image {
      border-radius: 3px !important;
    }
  }


.van-dialog__header {
  font-size: 18px;
  font-weight: bold;
  padding-top: 20px;
  line-height: 25px;
  height: 25px;
  text-align: center;
}
.modalBody {
  height: 160px;
  text-align: center;
  p {
    color: #333333;
    font-size: 15px;
    margin: 8px 0 24px;
  }
  textarea {
    background: #f5f6f7;
    border: none;
    font-size: 16px;
    margin: 0 auto 24px;
    height: 80px;
    letter-spacing: 2px;
    padding: 10px;
    width: 224px;
  }
  span {
    z-index: 9999;
    display: block;
    top: -54px;
    position: relative;
    text-align: right;
    font-size: 16px;
    color: #cccccc;
    width: 270px;
  }
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #f9591b;
  }


  .modalBody {
    height: 160px;
    text-align: center;
    p {
      color: #333333;
      font-size: 15px;
      height: 24px;
      line-height: 24px;
      margin: 8px 0 24px;
    }
    textarea {
      resize:none;
      background: #f5f6f7;
      border: none;
      font-size: 16px;
      margin: 0 auto;
      height: 80px;
      letter-spacing: 2px;
      padding: 10px;
      width: 224px;
    }
    span {
      z-index: 9999;
      display: block;
      bottom: 29px;
      right: 23px;
      position: relative;
      text-align: right;
      font-size: 16px;
      color: #cccccc;
      width: 270px;
    }
  
    .van-dialog__confirm,
    .van-dialog__confirm:active {
      color: #f9591b;
    }
  }
  .dialog1 {
    .van-dialog {
      width: 280px;
      // .van-dialog__header {
      //   font-size: 18px;
      //   font-weight: bold;
      //   padding-top: 20px;
      //   line-height: 25px;
      //   height: 25px;
      //   text-align: center;
      // }

      .van-dialog__content {
        margin-bottom: 12px;
      }
      .van-button {
        font-size: 17px;
      }
    }
  }
  .dialog2 {
    .van-dialog {
      // width: 280px;
      border-radius: 8px;
      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 15px 0 24px;
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }
}

  .loading5 {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
  .operation-box {
    // background-color: #f5f6f7;
    box-sizing: border-box;
    border-radius: 4px;
    // position: fixed;
    // bottom: 0;
    padding: 24px 15px;
  }

}
.red-text{
  color: #f9591b;
}

</style>